import { Box, Flex, VStack, Text, HStack } from '@chakra-ui/react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAdminAuth } from '../App'
import { LayoutDashboard, Users, BookOpen, DollarSign, Settings, LogOut, Shield, Layers } from 'lucide-react'

const NAV = [
  { label: 'Dashboard', icon: LayoutDashboard, path: '/' },
  { label: 'Users', icon: Users, path: '/users' },
  { label: 'Books', icon: BookOpen, path: '/books' },
  { label: 'Revenue', icon: DollarSign, path: '/revenue' },
  { label: 'Plans', icon: Layers, path: '/plans' },
  { label: 'Pricing', icon: Settings, path: '/pricing' },
]

export default function AdminLayout({ children }) {
  const { admin, logout } = useAdminAuth()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Flex minH="100vh" bg="#F7F7F5">
      <Box w="220px" minH="100vh" bg="brand.darkBlue" color="white" position="fixed" left={0} top={0} zIndex={100} display="flex" flexDirection="column">
        <Box px={5} py={5} borderBottom="1px solid rgba(255,255,255,0.1)">
          <HStack spacing={2} mb={1}>
            <Shield size={16} color="#E87300" />
            <Text fontSize="15px" fontWeight="700" fontFamily="Georgia, serif">WriteMills</Text>
          </HStack>
          <Text fontSize="10px" color="rgba(255,255,255,0.4)" letterSpacing="1.5px" textTransform="uppercase">Admin Panel</Text>
        </Box>

        <VStack spacing={1} p={3} flex={1} align="stretch">
          {NAV.map(item => {
            const isActive = location.pathname === item.path
            return (
              <Flex key={item.path} align="center" gap={3} px={3} py={2.5} borderRadius="8px" cursor="pointer"
                bg={isActive ? 'rgba(232,115,0,0.15)' : 'transparent'}
                borderLeft={isActive ? '3px solid #E87300' : '3px solid transparent'}
                color={isActive ? 'brand.orange' : 'rgba(255,255,255,0.6)'}
                _hover={{ bg: 'rgba(255,255,255,0.08)', color: 'white' }}
                transition="all 0.15s" onClick={() => navigate(item.path)}
              >
                <item.icon size={15} />
                <Text fontSize="13px" fontWeight={isActive ? '500' : '400'}>{item.label}</Text>
              </Flex>
            )
          })}
        </VStack>

        <Box px={4} py={4} borderTop="1px solid rgba(255,255,255,0.08)">
          <Text fontSize="12px" color="rgba(255,255,255,0.5)" mb={2}>{admin?.email}</Text>
          <Flex align="center" gap={2} cursor="pointer" color="rgba(255,255,255,0.4)" _hover={{ color: 'white' }} onClick={logout}>
            <LogOut size={14} />
            <Text fontSize="12px">Sign out</Text>
          </Flex>
        </Box>
      </Box>
      <Box ml="220px" flex={1} minH="100vh">{children}</Box>
    </Flex>
  )
}
